import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const to = searchParams.get('to');
  const platform = searchParams.get('platform');
  const company = searchParams.get('company');

  useEffect(() => {
    if (to) {
      // Here we could add analytics tracking if needed
      setTimeout(() => {
        window.location.href = decodeURIComponent(to);
      }, 1000);
    }
  }, [to]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography variant="h6">
        Redirecting to {platform} page for {company}...
      </Typography>
    </Box>
  );
};

export default RedirectPage;
